import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/hooks';
import { getProfile } from '../../../features/profile';

export const useProfileData = () => {
    const dispatch = useAppDispatch();
    const profile = useAppSelector(store => store.profile);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isActive = true;

        setLoading(true);
        dispatch(getProfile())
            .finally(() => {
                if (isActive) {
                    setLoading(false);
                }
            });

        return () => {
            isActive = false;
        };
    }, [dispatch]);

    return { profile, loading };
};
